import { makeStyles } from '@material-ui/core';

export const styles = makeStyles(() => ({
  grid: {
    display: 'block',
    whiteSpace: 'pre-wrap',
  },
}));
